import { Layout, PopoverMenu, Button } from '@wix/design-system';
import React from 'react';
import { ChevronDown } from '@wix/wix-ui-icons-common';
import { MultiBulkActionSubItemPrivate } from './MultiBulkActionProps';
import { useToolbarCollectionContext } from '../ToolbarCollectionContext';
import { MultiBulkActionToolbarState } from '../MultiBulkActionToolbar';
import { DisabledTooltip } from '../DisabledTooltip';
import { FiltersMap } from '@wix/bex-core';

export function MultiBulkActionPopover<T, F extends FiltersMap>(props: {
  actionItem: MultiBulkActionSubItemPrivate;
  state: MultiBulkActionToolbarState<T, F>;
}) {
  const { actionItem, state } = props;

  const { toolbarBIReporter } = useToolbarCollectionContext();

  const { dataHook, subItems, popoverMenuProps } = actionItem;

  return (
    <Layout cols={1} justifyItems="center">
      <PopoverMenu
        {...popoverMenuProps}
        dataHook={dataHook ? `${dataHook}-popover` : undefined}
        triggerElement={({ toggle }) => (
          <DisabledTooltip
            content={actionItem.tooltipText}
            dataHook={dataHook ? `${dataHook}-tooltip` : undefined}
          >
            <Button
              skin="standard"
              priority="secondary"
              size="small"
              dataHook={actionItem.dataHook}
              onClick={() => {
                toggle();
              }}
              prefixIcon={actionItem.prefixIcon}
              disabled={actionItem.disabled}
              suffixIcon={<ChevronDown />}
            >
              {actionItem.text}
            </Button>
          </DisabledTooltip>
        )}
      >
        {subItems?.map((subItem, index) => (
          <PopoverMenu.MenuItem
            prefixIcon={subItem.prefixIcon}
            disabled={subItem.disabled}
            text={subItem.text}
            key={index}
            dataHook={subItem.dataHook}
            onClick={() => {
              toolbarBIReporter.ctaClicked({
                location: 'multiBulkActionToolbar',
                ctaName: subItem.biName ?? '',
                ctaIndex: actionItem.biIndex + index + 1,
                moreActionsIndex: index + 1,
                componentId: subItem.componentId,
                appId: subItem.appId,
                numCtas:
                  state.primaryActionItems.length +
                  state.secondaryActionItems.length,
              });
              subItem.onClick?.();
            }}
          />
        ))}
      </PopoverMenu>
    </Layout>
  );
}
